import trackedFeatures from 'data/trackedFeatures.json';

export const siteCulture = window.utag_data.Language;

export const activeFeatureValues = window.utag_data.ActiveFeatureValues.map(featureValueString => parseInt(featureValueString, 10));

export const activeTrackedFeatures = trackedFeatures.filter((feature) => {
  const trackedFeatureValues = feature.values.map(value => value.id);

  return trackedFeatureValues.find(featureValue => activeFeatureValues.includes(featureValue)) !== undefined;
});



// WEBPACK FOOTER //
// ./src/settings/vistaprintContext.js